import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgRestaurantOutline24 = function SvgRestaurantOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.048 1.078c-.71.233-1.942 1.008-1.942 3.578v8.797h1.942V1.078zM21 .007V24h-.952v-9.588h-2.893V4.656c0-4.499 3.323-4.637 3.357-4.638L21 .007zM8.55 0h.952v9.452H6.726V24h-.951V9.452H3V0h.952v8.492h1.823V0h.951v8.492h1.825V0z",
    fill: "currentColor"
  })));
};

var RestaurantOutline24Svg = SvgRestaurantOutline24;

export { RestaurantOutline24Svg as default };
//# sourceMappingURL=RestaurantOutline24.svg.js.map
